module.exports = __webpack_public_path__ + "static/media/Weepinbell_gaussian2.49cba9f2.png";